import { render, staticRenderFns } from "./DeudaTotal.vue?vue&type=template&id=28032eeb&scoped=true"
import script from "./DeudaTotal.vue?vue&type=script&lang=js"
export * from "./DeudaTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28032eeb",
  null
  
)

export default component.exports